import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./FormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const CategoryBoosts = Loadable({
  loader: () => import('./CategoryBoostsPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Personalizations = Loadable({
  loader: () => import('./PersonalizationsPage'),
  loading: () => <Loading withContentWrapper />,
});

export const LearnedPersonalization = Loadable({
  loader: () => import('./LearnedPersonalizationPage'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./SearchAlgorithmsList'),
  loading: () => <Loading withContentWrapper />,
});

export const Preview = Loadable({
  loader: () => import('./AlgorithmPreviewPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Help = Loadable({
  loader: () => import('./AlgorithmHelpPage'),
  loading: () => <Loading withContentWrapper />,
});
